<h2 mat-dialog-title>Share template to catalogue</h2>
<mat-dialog-content>
  <p class="hint mb-3">
    Your submission goes to the review queue. Once approved, it appears in the public catalogue.
  </p>

  <form [formGroup]="form" class="share-form">
    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Title</mat-label>
      <input matInput formControlName="title" maxlength="25" />
    </mat-form-field>

    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Game</mat-label>
      <input
        matInput
        [formControl]="gameControl"
        [matAutocomplete]="gameAuto"
        (blur)="onGameBlur()"
        maxlength="50"
        required
      />
      <mat-autocomplete
        #gameAuto="matAutocomplete"
        [displayWith]="displayGame.bind(this)"
        (optionSelected)="onAutocompleteSelected($event)"
      >
        <mat-option *ngFor="let game of filteredGames$ | async" [value]="game">
          {{ game.name }}
        </mat-option>
        <mat-option *ngIf="showAddOption" [value]="pendingAddLabel">
          Add "{{ pendingAddLabel }}"
        </mat-option>
      </mat-autocomplete>
      <mat-hint *ngIf="createNewGame">New game name — added after approval</mat-hint>
    </mat-form-field>

    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Description</mat-label>
      <textarea matInput formControlName="description" rows="4" maxlength="1024"></textarea>
    </mat-form-field>

    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Notes for reviewer</mat-label>
      <textarea matInput formControlName="notes" rows="2" maxlength="1024"></textarea>
      <mat-hint>Optional — only the catalogue reviewer can see this (not public)</mat-hint>
    </mat-form-field>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close [disabled]="submitting">Cancel</button>
  <button mat-flat-button color="primary" [disabled]="submitting || form.invalid" (click)="submit()">
    Submit for review
  </button>
</mat-dialog-actions>
